import { XEnvironment as XEnvironmentDOM, xExtendClassForDOM } from './XDOM.js';
import { XTypeError } from './XError.js';
import { XStorage, xString } from './XTypes.js';
import XAPI from './XAPI.js';
import XResizeContainer from './XResizeContainer.js';
import * as XComponents from './XComponents.js';

export class XEnvironment
{
    #urlRoot;
    #urlAssets;

    #storage;
    #domEnvironment;
    #domTypes = {};
    #types = {};
    #api;
    #resizeContainer;

    initialize({
        urlRoot = '',
        urlAssets = '',
        resizeContainer = new XResizeContainer(document.documentElement),
        api = null,
        storage = null,
        types = [],
    })
    {
        this.#urlRoot = urlRoot;
        this.#urlAssets = urlAssets;
        this.#storage = storage;
        for(const type of types)
        {
            if(!('type' in type))
            {
                throw new XTypeError('Each domType needs to implement a static getter "type" to be registered', type);
            }
            if('specification' in type)
            {
                this.#storage.addTypes(type.specification);
            }
            if('_dom' in type.prototype)
            {
                xExtendClassForDOM(type);
                this.#domTypes[type.type] = type;
            }
            this.#types[type.type] = type;
        }
        this.#domEnvironment = new XEnvironmentDOM(this.#storage);
        this.#api = api;
        this.#resizeContainer = resizeContainer;
        for(const type of types)
        {
            if(type.initDOM)
            {
                type.initDOM(this.#domEnvironment);
            }
        }
    }
    
    set urlRoot   (urlRoot   ) { this.#urlRoot    = urlRoot;    }
    set urlAssets(urlAssets) { this.#urlAssets = urlAssets; }
    set storage   (storage   ) { this.#storage    = storage;    }
    set api       (api       ) { this.#api        = api;        }

    get urlRoot         () { return this.#urlRoot;         }
    get urlAssets      () { return this.#urlAssets;      }
    get storage         () { return this.#storage;         }
    get domEnvironment  () { return this.#domEnvironment;  }
    get domTypes        () { return this.#domTypes;        }
    get types           () { return this.#types;           }
    get api             () { return this.#api;             }
    get resizeContainer () { return this.#resizeContainer; }
}

export class XEnvironmentReactive extends XEnvironment
{
    #urlRoot = xString();

    set urlRoot(urlRoot) { this.#urlRoot._value = urlRoot; }

    get urlRoot  () { return this.#urlRoot._value; }
    get urlRoot_ () { return this.#urlRoot;        }

    #urlAssets = xString();

    set urlAssets(urlAssets) { this.#urlAssets._value = urlAssets; }

    get urlAssets  () { return this.#urlAssets._value; }
    get urlAssets_ () { return this.#urlAssets;        }
}

export function createEnvironmentStatic(api=new XAPI())
{
    if(!environments.static)
    {
        environments.static = new XEnvironment();
        environments.static.initialize({
            api: api,
            types: [
                XComponents.XImage,
                XComponents.XVideo,
                XComponents.XTextVoice,
                XComponents.XBlock,
                XComponents.XBlockStructure,
                XComponents.XContent,
                XComponents.XPage,
                XComponents.XPageMenuItem,
                XComponents.XSection,
                XComponents.XSite,
            ]
        });
    }
    environments.active = environments.static;
    return environments.active;
}

export function createEnvironmentReactive(api=new XAPI())
{
    if(!environments.reactive)
    {
        environments.reactive = new XEnvironmentReactive();
        environments.reactive.initialize({
            api: api,
            storage: new XStorage(),
            types: [
                XComponents.XImageReactive,
                XComponents.XVideoReactive,
                XComponents.XTextVoiceReactive,
                XComponents.XBlockReactive,
                XComponents.XBlockStructureReactive,
                XComponents.XContentReactive,
                XComponents.XPageReactive,
                XComponents.XPageMenuItemReactive,
                XComponents.XPageSettingsSEOReactive,
                XComponents.XPageSettingsSiteReactive,
                XComponents.XSectionReactive,
                XComponents.XSiteReactive,
            ]
        });
    }
    environments.active = environments.reactive;
    return environments.active;
}

const environments = {};
export default environments;